/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Unpin1Inputs */

const en_datagrid_unpin1 = /** @type {(inputs: Datagrid_Unpin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpin`)
};

/**
* | output |
* | --- |
* | "Unpin" |
*
* @param {Datagrid_Unpin1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_unpin1 = /** @type {((inputs?: Datagrid_Unpin1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Unpin1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_unpin1(inputs)
});
export { datagrid_unpin1 as "dataGrid_unpin" }